import { render, staticRenderFns } from "./result_normal.vue?vue&type=template&id=518e01ca&scoped=true"
import script from "./result_normal.vue?vue&type=script&lang=js"
export * from "./result_normal.vue?vue&type=script&lang=js"
import style0 from "./result_normal.vue?vue&type=style&index=0&id=518e01ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e01ca",
  null
  
)

export default component.exports